import React from "react";

const LoadingComp = ({ message, loaded }) => {
  const msg = message ? message : "Loading";

  return (
    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gray-100 bg-opacity-70 flex items-center justify-center backdrop-blur">
      <div className="p-4 bg-white rounded-lg shadow-lg flex items-center space-x-4">
        {!loaded && (
          <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500"></div>
        )}
        <p className="text-2xl tracking-[.1em] font-medium text-gray-700">
          {msg}
          {!loaded && (
            <span className="loading loading-dots tracking-[.2em] loading-xs align-bottom"></span>
          )}
        </p>
      </div>
    </div>
  );
};

export default LoadingComp;
